/**
 * Extracts the agent workspace folder ID from application state, regardless of agent type.
 *
 * Background agents/routines can create folder-scoped chats under any agent type (not just
 * co-scientist), and a workspace folder alone now also confers "full access" from the user's
 * perspective (see hasFullAccessForDisplay in ChatStateUtil). Callers that need the co-scientist-only
 * UI (workspace folder chip/picker in the chat input) should additionally check the agent type
 * themselves.
 */
export function getAgentWorkspaceFolderId(applicationState: object | null): string | null {
  if (applicationState == null) {
    return null;
  }

  const state = applicationState as {agent_workspace_folder_id?: unknown};
  if (typeof state.agent_workspace_folder_id !== 'string') {
    return null;
  }

  return state.agent_workspace_folder_id;
}
